// import { Link } from "gatsby";
import React, { useState, useEffect } from "react";
// import { Field, Form, Formik } from "formik";
import { useStaticQuery, graphql } from "gatsby";

import { Link } from "gatsby";
import SiteTrans from "../../LangConfig/siteTrans.json";
import LangConfig from "../../LangConfig/LangConfig.json";
import CookieConsent from "../cookie-consent";
import FooterMenuLocation1 from "./footerMenuLocation1";
import FooterMenuLocation2 from "./footerMenulocation2";
import FooterMenuLocation3 from "./footerMenulocation3";
import FooterMenuLocation4 from "./footerMenulocation4";
import FooterMenuLocation5 from "./footerMenulocation5";
import linkedIn from "../../../common/images/Global/footer/linkedIn.svg";
import facebook from "../../../common/images/Global/footer/facebook.svg";
import instagram from "../../../common/images/Global/footer/instagram.svg";
import youtube from "../../../common/images/Global/footer/youtube.svg";
// import brandMatrixOne from "../../../common/images/Global/footer/brandMatrixOne.svg";
// import brandMatrixTwo from "../../../common/images/Global/footer/brandMatrixTwo.svg";
import playStore from "../../../common/images/Global/footer/playStore.svg";
import appStore from "../../../common/images/Global/footer/appStore.svg";
import qrCode from "../../../common/images/Global/footer/qrCode.svg";


const FooterBackup = (props) => {

  const [cookieShow, setCookieShow] = useState(false)
  useEffect(() => {
    localStorage.getItem('consentCookieHidden') === true ? setCookieShow(false) : setCookieShow(true);
  }, [])


  

  // {
  //   genericSocialLinks: allWp {
  //     edges {
  //       node {
  //         themeGeneralSettings {
  //           themeSettings {
  //             appleStoreLink
  //             facebookLink
  //             fieldGroupName
  //             googlePlayLink
  //             instagramLink
  //             linkedinLink
  //             youtubeLink
  //           }
  //         }
  //       }
  //     }
  //   }

  const menuqry = useStaticQuery(graphql`
  
    {
      

     
       
    genericSocialLinks:  wpGlobalsetting(slug: {eq: "theme-settings"}, locale: {id: {eq: "en_US"}}) {
      id
      themesettings {
        appleStoreLink
        facebookLink
        googlePlayLink
        instagramLink
        linkedinLink
        youtubeLink
      }
    }

    genericEn: wpGlobalsetting(slug:{eq: "theme-settings"},locale: {id: {eq: "en_US"}}){
      id
      locale {
        id
      }
      seo {
        opengraphTitle
        opengraphDescription
      }
      themesettings {
        copyright
      }
    }

    genericAr: wpGlobalsetting(slug:{eq: "theme-settings"},locale: {id: {eq: "ar"}}){
      id
      locale {
        id
      }
      seo {
        opengraphTitle
        opengraphDescription
      }
      themesettings {
        copyright
      }
    }

    genericZhcn: wpGlobalsetting(slug:{eq: "theme-settings"},locale: {id: {eq: "zh_CN"}}){
      id
      locale {
        id
      }
      seo {
        opengraphTitle
        opengraphDescription
      }
      themesettings {
        copyright
      }
    }


    menuEn:  wpMenu(name: {eq: "Footer Auxiliary Menu"}) {
      menuItems {
        nodes {
          label
          parentId
          url
          id
          databaseId
        }
      }
  }

    menuAr:  wpMenu(name: {eq: "Footer Auxiliary Menu AR"}) {
      menuItems {
        nodes {
          label
          parentId
          url
          id
          databaseId
        }
      }
  }

  menuZhcn:  wpMenu(name: {eq: "Footer Auxiliary Menu ZHCN"}) {
    menuItems {
      nodes {
        label
        parentId
        url
        id
        databaseId
      }
    }
}



  }
  
`);

const menulist = props.lang==="en_US" ? menuqry.menuEn
      : props.lang==="ar" ? menuqry.menuAr
      : props.lang==="zh_CN" ? menuqry.menuZhcn : menuqry.menuEn


      const genericFooterContent = props.lang==="en_US" ? menuqry.genericEn
      : props.lang==="ar" ? menuqry.genericAr
      : props.lang==="zh_CN" ? menuqry.genericZhcn : menuqry.genericEn

      console.log(props.lang,"props.lang");


// const menulist = menuqry.menuEn;
  // const currentPage = props.data.wpPage;
  const [formState, setFormState] = useState({
    fname: "",
    lname: "",
    email: "",
    languageid: "",
    language: "",
    ageConsent: false,
    dataConsent: false,
    status: false,
    statusMsg: "",
    error: false,
    errorMsg: "",
  });
  const [errorState, setErrorState] = useState({
    fname: "",
    lname: "",
    email: "",
    languageid: "",
    language: "",
    ageConsent: false,
    dataConsent: false,
    status: false,
    statusMsg: "",
    error: false,
    errorMsg: "",
  });

  const footerSubmission = () => {
    let err = false;
    // let errMsg = "";
    let emailErr, fnameErr, lnameErr, ageConsentErr, dataConsentErr, languageidErr;
    let re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (formState.fname === "") {
      err = true;
      fnameErr = SiteTrans.please_enter_your_first_name[props.lang];
    }
    if (formState.lname === "") {
      err = true;
      lnameErr = SiteTrans.please_enter_your_last_name[props.lang];
    }
    if (formState.languageid === "") {
      err = true;
      languageidErr = SiteTrans.please_select_language[props.lang];
    }
    if (!re.test(formState.email)) {
      err = true;
      emailErr = SiteTrans.becomepartner_email_err[props.lang];
    }
    if (formState.ageConsent === false) {
      err = true;
      ageConsentErr = SiteTrans.contact_confirm_message_err[props.lang];
    }
    if (formState.dataConsent === false) {
      err = true;
      dataConsentErr = SiteTrans.contact_consent_message_err[props.lang];
    }

    if (err) {
      setErrorState({
        ...errorState,
        error: true,
        fname: fnameErr,
        lname: lnameErr,
        email: emailErr,
        languageid: languageidErr,
        ageConsent: ageConsentErr,
        dataConsent: dataConsentErr,
      });
    } else {
      var axios = require("axios");

      var FormData = require("form-data");
      var data = new FormData();
      data.append("flag", true);
      data.append("formtype", "newsletter");
      data.append("email", formState.email);
      data.append("firstname", formState.fname);
      data.append("lastname", formState.lname);
      data.append("ageConsent", formState.ageConsent);
      data.append("dataConsent", formState.dataConsent);
      data.append("language", formState.languageid);

      var config = {
        method: "post",
        url: "https://editor.jameelmotors.com/wp-content/themes/jameelmotors/addCf7.php",
        headers: {},
        data: data,
      };

      // var mainJson = {
      //   formEndpoint:
      //     "https://cms.jameelmotors.com/wp-content/themes/jameelmotors/addCf7.php",
      //   project: "Jameel Health",
      //   formName: "Newsletter Subscription",
      //   slackUrl: "",
      //   formData: {
      //     email: formState.email,
      //     firstname: formState.fname,
      //     lastname: formState.lname,
      //     ageConsent: formState.ageConsent,
      //     dataConsent: formState.dataConsent,
      //   },
      // };

      // var data = JSON.stringify(mainJson);
      // var config = {
      //   method: "post",
      //   url: "https://qb2zboq3ih.execute-api.eu-west-2.amazonaws.com/prod/sqs",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   data: data,
      // };

      axios(config)
        .then(function (response) {
          // //console.log(JSON.stringify(response.data));
          // recaptchaInstance.reset();
          setFormState({
            ...formState,
            fname: "",
            lname: "",
            email: "",
            languageid: "",
            ageConsent: false,
            dataConsent: false,
            status: true,
            statusMsg: SiteTrans.thank_you_for_subscribing_to_our_newsletter[props.lang],
            error: false,
            errorMsg: "",
          });
          setErrorState({
            fname: false,
            lname: false,
            email: false,
            languageid: false,
            ageConsent: false,
            dataConsent: false,
            status: false,
            statusMsg: "",
            error: false,
            errorMsg: "",
          });
        })
        .catch(function (error) {
          // //console.log(error);
          // recaptchaInstance.reset();
          setFormState({
            ...formState,

            status: false,
            statusMsg: "",
            error: true,
            errorMsg:
            SiteTrans.there_was_an_error_saving_your_request[props.lang],
          });
          setErrorState({
            fname: false,
            lname: false,
            email: false,
            languageid: false,
            ageConsent: false,
            dataConsent: false,
            status: false,
            statusMsg: "",
            error: false,
            errorMsg: "",
          });
        });
    }
  };
  let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const fnameErr1 = errorState.fname === true ? "validations-error" : "noerror";
  const lnameErr1 = errorState.lname === true ? "validations-error" : "noerror";
  const emailErr1 = errorState.email === true ? "validations-error" : "noerror";
  const languageidErr1 = errorState.languageid === true ? "validations-error" : "noerror";



  return (
    <div className="customPageContainer footer-wrapper">
      <div className="position-relative z-2">
        <div className="footer-nav-box">
          <div className="container">
            <div className="footer-nav-wrapper">
              <div className="row row-cols-2 row-cols-sm-3 row-cols-md-5 footer-nav-container col-md-">
                <div className="footer-nav-title-links col">
                  <div className="footer-nav-title">{SiteTrans.footer_heading_1[props.lang]}</div>
                  <ul>
                    <FooterMenuLocation1 lang={props.lang} />
                  </ul>
                </div>
                <div className="footer-nav-title-links col">
                  <div className="footer-nav-title">{SiteTrans.what_we_do_label[props.lang]}</div>
                  <ul>
                    <FooterMenuLocation2 lang={props.lang} />
                  </ul>
                </div>
                <div className="footer-nav-title-links col">
                  <div className="footer-nav-title">{SiteTrans.news_insigts_section_heading[props.lang]}</div>
                  <ul>
                    <FooterMenuLocation3 lang={props.lang} />
                  </ul>
                </div>
                <div className="footer-nav-title-links col">
                  <ul>
                    <FooterMenuLocation4 lang={props.lang} />
                  </ul>
                </div>
                <div className="footer-nav-title-links col">
                  <div className="footer-nav-title">{SiteTrans.the_jameel_philanthropies[props.lang]}</div>
                  <ul>
                    <FooterMenuLocation5 lang={props.lang} />
                  </ul>
                </div>
              </div>
              <div className="social-links-label-wrapper">
                <div className="join-the-conversation-label">
                {SiteTrans.follow_us_and_join_the_conversation[props.lang]}
                </div>
                <div className="social-links-wrapper">
                  <a  target="_blank" rel="noreferrer" href={menuqry.genericSocialLinks.themesettings.linkedinLink}>
                    <img
                      className="social-icon"
                      src={linkedIn}
                      alt="Jameel Motors"
                      width={20}
                      height={20}
                    /></a>
                  <a target="_blank" rel="noreferrer" href={menuqry.genericSocialLinks.themesettings.facebookLink}>
                    <img
                      className="social-icon"
                      src={facebook}
                      alt="Jameel Motors"
                      width={20}
                      height={20}
                    />
                  </a>
                  <a target="_blank" rel="noreferrer" href={menuqry.genericSocialLinks.themesettings.instagramLink}>
                    <img
                      className="social-icon"
                      src={instagram}
                      alt="Jameel Motors"
                      width={20}
                      height={20}
                    />
                  </a>
                  <a target="_blank" rel="noreferrer" href={menuqry.genericSocialLinks.themesettings.youtubeLink}>
                    <img
                      className="social-icon"
                      src={youtube}
                      alt="Jameel Motors"
                      width={20}
                      height={20}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="newsletter-form-wrapper">
          <div className="newsletter-form-container">
            <div className="newsletter-signup-title">
            {SiteTrans.footer_newsletter_heading[props.lang]}
            </div>

            <div className="newsletter-fields-box">
              <div className="newsletter-fields-container">

                <div className="newsletter-fields-wrapper">
                  <div className="news-letter-fields-box">
                    <div className="newsletter-fields-error-container">
                      <input
                        type="text"
                        className={`form-control font-exsm first-name ${fnameErr1}`}
                        // placeholder={
                        //   SiteTrans.footer_form_firstname[props.lang]
                        // }
                        placeholder={SiteTrans.contact_fname[props.lang]}
                        name="firstName"
                        value={formState.fname}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            fname: e.target.value,
                          });
                          setErrorState({
                            ...errorState,
                            fname: "", // Clear the error message
                          });
                        }}
                      />
                      {errorState.fname ? (
                        <span className="error-message font-exsm">
                          {errorState.fname}
                        </span>
                      ) : null}
                    </div>

                    <div className="newsletter-fields-error-container">
                      <input
                        type="text"
                        className={`form-control font-exsm last-name ${lnameErr1}`}
                        // placeholder={SiteTrans.footer_form_lastname[props.lang]}
                        placeholder={SiteTrans.contact_lname[props.lang]}
                        name="lastName"
                        value={formState.lname}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            lname: e.target.value,
                          });
                          setErrorState({
                            ...errorState,
                            lname: "", // Clear the error message
                          });
                        }
                        }
                      />
                      {errorState.lname ? (
                        <span className="error-message font-exsm">
                          {errorState.lname}
                        </span>
                      ) : null}
                    </div>

                  </div>

                  <div className="news-letter-fields-box">
                    <div className="newsletter-fields-error-container">
                      <input
                        type="text"
                        className={`form-control font-exsm email-address ${emailErr1}`}
                        // placeholder={SiteTrans.footer_form_email[props.lang]}
                        placeholder={SiteTrans.locations_email_lable[props.lang]}
                        name="email"
                        value={formState.email}
                        onChange={(e) => {
                          const email = e.target.value;
                          setFormState({
                            ...formState,
                            email: email,
                          });

                          // Check if the email is valid and clear the error message accordingly
                          if (emailRegex.test(email)) {
                            setErrorState({
                              ...errorState,
                              email: "", // Clear the error message for a valid email
                            });
                          } else {
                            setErrorState({
                              ...errorState,
                              email: SiteTrans.becomepartner_email_err[props.lang],
                            });
                          }
                        }
                        }
                      />
                      {errorState.email ? (
                        <span className="error-message font-exsm">
                          {errorState.email}
                        </span>
                      ) : null}

                    </div>
                    <div className="newsletter-fields-error-container">

                      <select
                        className={`language-select-form font-exsm form-select ${languageidErr1}`}
                        aria-label="Languages"
                        name="language"
                        value={formState.languageid}
                        onChange={(e) => {
                          setFormState({
                            ...formState,
                            languageid: e.target.value,
                            language: e.target.value
                          });
                        }}
                      >
                        <option hidden className="font-exsm">
                          {SiteTrans.language_label[props.lang]}
                        </option>
                        <option  className="font-exsm"value="EN">English</option>
                        <option  className="font-exsm"value="AR">العربية</option>
                        <option  className="font-exsm"value="ZH_CN">简体中文</option>
                      </select>
                      {errorState.languageid ? (
                        <span className="error-message font-exsm">
                          {errorState.languageid}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="consents-wrapper">
                  <div className="form-check">
                    <label className="form-check-label consents">
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="ageConsent"
                          checked={formState.ageConsent}
                          onChange={(e) => {
                            setFormState({
                              ...formState,
                              ageConsent: e.target.checked,
                            });
                            setErrorState({
                              ...errorState,
                              ageConsent: "",
                            });
                          }
                          }
                        />
                        {/* {SiteTrans.footer_confirm_message[props.lang]} */}
                        <p>
                        {SiteTrans.contact_confirm_message[props.lang]}
                        </p>
                      </div>
                      {errorState.ageConsent ? (
                        <span className="error-message font-exsm">
                          {errorState.ageConsent}
                        </span>
                      ) : null}
                    </label>
                  </div>

                  <div className="form-check">
                    <label className="form-check-label consents">
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="dataConsent"
                          checked={formState.dataConsent}
                          onChange={(e) => {
                            setFormState({
                              ...formState,
                              dataConsent: !formState.dataConsent,
                            });
                            setErrorState({
                              ...errorState,
                              dataConsent: "",
                            });
                          }
                          }
                        />
                        {/* {SiteTrans.footer_consent_message[props.lang]} */}
                        <p>
                        {SiteTrans.contact_consent_message[props.lang]}
                        </p>
                      </div>
                      {errorState.dataConsent ? (
                        <span className="error-message font-exsm">
                          {errorState.dataConsent}
                        </span>
                      ) : null}
                    </label>
                  </div>
                </div>
                <strong>
                  {formState.status ? (
                    <span className="thankyoumessage-newsletter mb-4">
                      {" "}
                      {formState.statusMsg}
                    </span>
                  ) : null}
                </strong>

              </div>

              <button
                type="submit"
                className="newsletter-submit-btn"
                onClick={footerSubmission}
              >
                {SiteTrans.footer_form_submitbtn[props.lang]}
              </button>

            </div>

          </div>
          <div className="mobile-app-ad-wrapper" onMouseOver={(event) => { }}>
            <div className="download-app-title">
            {SiteTrans.footer_download_app_txt[props.lang]}
            </div>
            <div className="playstore-appstore-wrapper">
              <a target="_blank" rel="noreferrer" href={menuqry.genericSocialLinks.themesettings.googlePlayLink}>
                <button>

             
                <img
                  src={playStore}
                  alt="Jameel Motors"
                  className="play-store-button"
                  width={121}
                  height={36}
                />
                   </button>
              </a>
              <a target="_blank" rel="noreferrer" href={menuqry.genericSocialLinks.themesettings.appleStoreLink}>
                <img
                  src={appStore}
                  alt="Jameel Motors"
                  className="app-store-button"
                  width={121}
                  height={36}
                />
              </a>
            </div>
            <div className="qr-code-wrapper">
              <div className="qr-code-label">{SiteTrans.scan_the_qr_code[props.lang]}</div>
              <img
                src={qrCode}
                alt="Jameel Motors"
                className="qr-code"
                width={73}
                height={72}
              />
            </div>
          </div>
        </div>
        <div className="divider"></div>
       
        {/* <div className="copywright-info">
          © 2015-2023 Abdul Latif Jameel IPR Company Limited. Permission to
          use this site is granted strictly subject to the{" "}
          <Link to="" className="terms-of-use font-exsm">
            Terms of Use
          </Link>
          . The Abdul Latif Jameel name and the Abdul Latif Jameel logotype
          and pentagon-shaped graphics are trademarks or registered trademarks
          of Abdul Latif Jameel IPR Company Limited.
          </div> */}
        <div className="copywright-info">
          {genericFooterContent.themesettings.copyright}
        </div>

        <div className="policy-and-terms-docs-links">
          {
      menulist!== null ? 
        menulist.menuItems.nodes.map((item,index) => (
          item.parentId===null?                    
              <li key={index}>
                  {                           
                  // <Link className="footer-nav-links" to={`/${LangConfig[props.lang]["slug"]}/${item.url.replace('/home','').replace('/','')}`} key={item.label} title={item.label}> {item.label} </Link>
                  <Link className="company-legal-links" to={`/${LangConfig[props.lang]["slug"]}/${item.url.replace('/home','').replace('/','')}`} key={item.label} title={item.label}> {item.label} </Link>
                  }                       
              </li>                    
              :null
        ))
      :null
    }
{/*     
          <Link to="/en/terms-of-use" className="company-legal-links">Terms of Use</Link>
          <Link to="/en/copyright-notice-and-disclaimer" className="company-legal-links">
            Copyright Notice and Disclaimer
          </Link>
          <Link to="/en/privacy-policy" className="company-legal-links">Privacy Policy</Link>
          <Link to="/en/accessibility-policy" className="company-legal-links">Accessibility Policy</Link>
          <Link to="/en/cookie-policy" className="company-legal-links">Cookie Policy</Link>
          <Link className="company-legal-links" to="/en/contact-us">
            Contact Us
          </Link>
          <Link className="company-legal-links" to='/en/sitemap/'>Sitemap</Link> */}

        </div>
        <div className="bottom-footer">
          <div className="container">
            {/* <CookieConsent /> */}
            {cookieShow ? <CookieConsent lang={props.lang} /> : ""}
          </div>
        </div>
      </div>
    </div>



  );
};

export default FooterBackup;
// export const genericPage = graphql`
//   query genericPage {
//     wpPage(slug: {eq: "theme-settings"}, locale: {id: {eq: "en_US"}}){
//       id
//       featuredImage {
//         node {
//           gatsbyImage(width: 1320, placeholder: BLURRED)
//           altText
//         }
//       }
//       locale {
//         id
//       }
//       seo {
//         opengraphTitle
//         opengraphDescription
//       }
//       themesettings {
//         cookieConsent
//       }
//     }
//   }
// `;
